import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { IncludedSection } from '../components/IncludedSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="w-full min-h-screen bg-white" data-id="element-233">
      <Hero data-id="element-234" />
      <ProblemSection data-id="element-235" />
      <SolutionSection data-id="element-236" />
      <BenefitsSection data-id="element-237" />
      <IncludedSection data-id="element-238" />
      <ForWhomSection data-id="element-239" />
      <PricingSection data-id="element-240" />
      <Footer data-id="element-241" />
    </main>;
}